import React, { useEffect, useState } from 'react'
import { Form } from 'react-final-form'
import Header from '../components/Header/Header'
import { useSearchCarDrivetrainMutation } from '../../../services'
import { UspConfigurationCarDrivetrainViewResult } from '../../../models'
import InventoryDrivetrainsTable from './components/InventoryDrivetrainsTable'
import AddEditDrivetrainsModal from './components/AddEditDrivetrainsModal'
import { Button, Card, Container, Grid } from '@mui/material'
import CustomBreadcrumbs from '../../../components/custom-breadcrumbs/custom-breadcrumbs'
import Iconify from '../../../components/iconify'

const SettingsInventoryDrivetrains = () => {
  const [rowData, setRowData] = useState({})
  const [openAddEditModal, setOpenAddEditModal] = useState(false)
  const [type, setType] = useState('')
  const [searchCarDrivetrain, { data, isLoading }] = useSearchCarDrivetrainMutation()
  const [carDrivetrainData, setCarDrivetrainData] = useState<UspConfigurationCarDrivetrainViewResult[]>([])

  const handleSubmit = (values?: any) => {
    searchCarDrivetrain({
      uspConfigurationCarDrivetrainView: {
        searchString: values?.searhString,
        isIncludeInactive: values?.isIncludeInactive,
      },
    })
  }

  const handleOpenModal = () => {
    setOpenAddEditModal(true)
    setType('add')
  }

  const handleCloseModal = () => {
    setOpenAddEditModal(false)
  }

  useEffect(() => {
    if (data) {
      setCarDrivetrainData(data)
    }
  }, [data])

  return (
    <Container>
      <CustomBreadcrumbs
        heading='Drivetrains'
        links={[
          {
            name: 'List',
          },
        ]}
        action={
          <>
            <Button onClick={handleOpenModal} variant='contained' startIcon={<Iconify icon='mingcute:add-line' />}>
              Add new
            </Button>
          </>
        }
        sx={{
          mb: {
            xs: 3,
            md: 5,
          },
        }}
      />
      <Form onSubmit={handleSubmit} initialValues={{ searhString: null, isIncludeInactive: false }}>
        {({ handleSubmit, form: { submit } }: any) => (
          <>
            <form onSubmit={handleSubmit}>
              <Card>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Header submit={submit} title='' handleOpenModal={handleOpenModal} />
                  </Grid>
                  <Grid item xs={12}>
                    <InventoryDrivetrainsTable
                      setOpenAddEditModal={setOpenAddEditModal}
                      setType={setType}
                      setRowData={setRowData}
                      handleOpenModal={handleOpenModal}
                      loading={isLoading}
                      data={carDrivetrainData}
                      setData={setCarDrivetrainData}
                    />
                  </Grid>
                </Grid>
              </Card>
            </form>
            <AddEditDrivetrainsModal
              submit={submit}
              open={openAddEditModal}
              onClose={handleCloseModal}
              type={type}
              rowData={rowData as UspConfigurationCarDrivetrainViewResult}
            />
          </>
        )}
      </Form>
    </Container>
  )
}

export default SettingsInventoryDrivetrains
